module.exports = __webpack_public_path__ + "img/time_line_diamond.22a9c88d.svg";